import React from "react";
import { JssProvider, createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../../jss_setup";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { useContext } from "react";
import { useState } from "react";
import { Button } from "../../../components/common/Button";
import { InlineIcon } from "@iconify/react";
import { useRef } from "react";

import { ProductReservations } from "./ProductReservations";
import { productTypes } from "./helpers";
import { useSelector } from "react-redux";
import { getProductCategoriesSelector } from "../../../umbilical_hocs";

const products = [
  ["ACC", "hotels"],
  ["FL", "flights"],
  ["TRF", "transfers"],
  ["ACT", "activities"],
  ["MI", "addOns"],
  ["FER", "ferries"],
  ["TRA", "trains"],
  ["CAR", "carRentals"],
];

const prodSelectionNavtyles = createUseStyles({
  ProdSelectionNav: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr max-content",
    gridGap: jssVariables.half_gap,
    alignItems: "baseline",
    ...(props?.customStyles?.ProdSelectionNav ?? {}),
  }),
  productTypes: (props) => ({
    display: "grid",
    gridAutoFlow: "column",
    gridAutoColumns: "max-content",
    gridGap: jssVariables.half_gap,
    overflow: "auto",
    paddingBottom: jssVariables.normal_gap,
    ...(props?.customStyles?.productTypes ?? {}),
  }),
  angle: (props) => ({
    fontSize: "large",
    width: "1rem",
    height: "2rem",
    display: "grid",
    alignSelf: "center",
    ...(props?.customStyles?.angle ?? {}),
  }),
  angleIcon: (props) => ({
    color: jssVariables.colors.base_color,
    ...(props?.customStyles?.angleIcon ?? {}),
  }),
  btnContr: (props) => ({
    ...(props?.customStyles?.btnContr ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    Reservations: (props) => ({
      padding: jssVariables.double_gap,
      width: "max-content",
      ...(props?.customStyles?.Reservations?.smallscreen ?? {}),
    }),
    ProdSelectionNav: (props) => ({
      gridGap: jssVariables.normal_gap,
      ...(props?.customStyles?.ProdSelectionNav?.smallscreen ?? {}),
    }),
    btnContr: (props) => ({
      width: "7rem",
      ...(props?.customStyles?.btnContr?.smallscreen ?? {}),
    }),
    angle: (props) => ({
      display: "none",
      ...(props?.customStyles?.angle?.smallscreen ?? {}),
    }),
  },
});
export const ProdSelectionNav = ({
  customStyles,
  productType,
  setProductType,
}) => {
  const classes = prodSelectionNavtyles({ customStyles });

  const scrollRef = useRef(null);

  const { t } = useContext(TranslationContext);

  const product_types = useSelector((state) =>
    getProductCategoriesSelector(state)
  );

  const productOptions = products.filter((product) =>
    product_types.includes(product[0])
  );

  return (
    <div className={classes.ProdSelectionNav}>
      <div
        className={classes.angle}
        onClick={() => {
          const curr = scrollRef.current;
          curr.scrollTo(curr.scrollLeft - 100, 0);
        }}>
        <InlineIcon icon="fa6-solid:angle-left" className={classes.angleIcon} />
      </div>
      <div className={classes.productTypes} ref={scrollRef}>
        {productOptions.map((option, idx) => (
          <div className={classes.btnContr} key={idx}>
            <JssProvider classNamePrefix={`reservNavBtn___${idx}-`}>
              <Button
                text={t(option[1])}
                empty={productType !== option[0]}
                revert={productType !== option[0]}
                customStyles={{
                  ButtonDefault: customStyles?.ReservationsNavBtn ?? {},
                }}
                onClick={() => setProductType(option[0])}
              />
            </JssProvider>
          </div>
        ))}
      </div>
      <div
        className={classes.angle}
        onClick={() => {
          const curr = scrollRef.current;
          curr.scrollTo(curr.scrollLeft + 100, 0);
        }}>
        <InlineIcon
          icon="fa6-solid:angle-right"
          className={classes.angleIcon}
        />
      </div>
    </div>
  );
};
ProdSelectionNav.defaultProps = { customStyles: {}, productType: "" };
ProdSelectionNav.propTypes = {
  customStyles: PropTypes.object,
  productType: PropTypes.string.isRequired,
  setProductType: PropTypes.func.isRequired,
};

const styles = createUseStyles({
  Reservations: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    padding: jssVariables.normal_gap,
    background: "white",
    borderRadius: jssVariables.half_gap,
    boxShadow: jssVariables.shadows.normalShadow,
    ...(props?.customStyles.Reservations ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    Reservations: (props) => ({
      padding: jssVariables.double_gap,
      ...(props?.customStyles?.Reservations?.smallscreen ?? {}),
    }),
  },
});
export const Reservations = () => {
  const [productType, setProductType] = useState("ACC");

  const product_types = useSelector((state) =>
    getProductCategoriesSelector(state)
  );

  const { t } = useContext(TranslationContext);
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "ReservationsStyles",
  });

  const classes = styles({ customStyles });

  return (
    <div className={classes.Reservations}>
      {product_types.length > 1 && (
        <React.Fragment>
          <h4>{`${t(productTypes[productType])} ${t("reservations")}`}</h4>
          <ProdSelectionNav
            productType={productType}
            setProductType={setProductType}
            customStyles={customStyles}
          />
        </React.Fragment>
      )}
      <ProductReservations productType={productType} />
    </div>
  );
};
